<template>

    <div class="container-center">

        <div class="inviteInfo solid">
            <el-button v-if="infoData.isSign=='1'" class="btn-managers" @click="managersDialogShow = true">项目经理
            </el-button>
            <p :class="[infoData.finvitemethod.charAt(0) === '3' ? 'strategy' : '', 'title']">{{infoData.fname}}</p>
            <p>发布时间：{{ infoData.fdistributedate }}</p>
        </div>
        <div class="inviteInfo dashed" v-if="infoData.isSign=='0'">
            <h5>招标信息</h5>
            <el-row>

                
                <el-col :span="3">招标项概况：</el-col>
                <el-col :span="21">
                    <div v-for="item in finvitecontentArr">{{item}}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">入围资质、资质要求：</el-col>
                <el-col :span="21">
                    <div v-for="item in fqulificademandArr">{{item}}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">报名须知：</el-col>
                <el-col :span="21">
                    <div v-for="item in signNoticeArr">{{ item }}</div>
                </el-col>
            </el-row>
        </div>
        <div class="inviteInfo dashed" v-else-if="infoData.isSign=='1'">
            <h5>招标信息</h5>
            <el-row>
                <el-col :span="3">招标项概况：</el-col>
                <el-col :span="21">
                    <div v-for="item in finvitecontentArr">{{item}}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">入围资质、资质要求：</el-col>
                <el-col :span="21">
                    <div v-for="item in fqulificademandArr">{{item}}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">报名须知：</el-col>
                <el-col :span="21">
                    <div v-for="item in signNoticeArr">{{ item }}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">投标保证金说明：</el-col>
                <el-col :span="21">
                    <div v-for="item in cashDepositDesArr">{{ item }}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">特别提示：</el-col>
                <el-col :span="21">
                    <div v-for="item in hotTipArr">{{ item }}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">报名开始时间：</el-col>
                <el-col :span="21">{{ infoData.cfinvregisteddeadlinest }}</el-col>
            </el-row>
            <el-row>
                <el-col :span="3">报名截止时间：</el-col>
                <el-col :span="21">{{ infoData.finvregisteddeadline }}</el-col>
            </el-row>
        </div>

        <div v-if="infoData.isSign=='0' && !isStrategy" class="inviteInfo dashed">
            <h5>标段信息</h5>
            <div v-if="infoData.segmentList.length == 0" class="no-data-tip"></div>
            <div v-else class="invite-unit" v-for="o in infoData.segmentList" :key="o.fid">
                <el-row>
                    <el-col :span="6">标段：</el-col>
                    <el-col :span="18">{{ o.fcurprojectname +'-'+ o.fbidnum }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">所属项目：</el-col>
                    <el-col :span="18">{{ o.fcurprojectname }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">产品及服务：</el-col>
                    <el-col :span="18">
                <span v-for="oo,index in o.productTypeList" :key="oo.fid">
                    <span v-if="index > 0">、</span>{{ oo.fnameL2 }}
                </span>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="inviteInfo dashed">
            <h5>联系信息</h5>
            <el-row>
                <el-col :span="3">招标负责人：</el-col>
                <el-col :span="21">{{ infoData.fresppersonName }}</el-col>
            </el-row>
            <el-row>
                <el-col :span="3">联系电话：</el-col>
                <el-col :span="21">{{ infoData.fphone}}</el-col>
            </el-row>
            <el-row>
                <el-col :span="3">电子邮箱：</el-col>
                <el-col :span="21">{{ infoData.femail }}</el-col>
            </el-row>
            <el-row>
                <el-col :span="3">地址：</el-col>
                <el-col :span="21">{{ infoData.faddress }}</el-col>
            </el-row>
        </div>

        <div v-if="infoData.isSign=='1' && !isStrategy" class="inviteInfo">
            <h5>标段信息</h5>
            <div v-for="o in infoData.segmentList" class="inviteInfo dashed segment" :key="o.fid">
                <el-row>
                    <el-col :span="3">标段：</el-col>
                    <el-col :span="5">{{ o.fcurprojectname +'-'+ o.fbidnum }}
                        <el-tag v-if="o.hasSign" type="warning" size="mini">已报名</el-tag>
                    </el-col>
                    <el-col :span="3">所属项目：</el-col>
                    <el-col :span="5">{{ o.fcurprojectname }}</el-col>
                    <el-col :span="3">产品及服务：</el-col>
                    <el-col :span="5">
                        <span v-for="(oo,index) in o.productTypeList" :key="oo.fid"><span v-if="index > 0">、</span>{{ oo.fnameL2 }}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">报名联系人：</el-col>
                    <el-col :span="5">{{ infoData.linkpersonList[0].fpersonname }}</el-col>
                    <el-col :span="3">联系人电话：</el-col>
                    <el-col :span="5">{{ infoData.linkpersonList[0].fphone }}</el-col>
                </el-row>
            </div>
        </div>

        <div class="text-center">
            <el-button v-if="infoData.isSign=='0' && !isSignEnd" type="warning" size="medium" @click="signInfoShow=true"
                       class="btn-theme">报名
            </el-button>
            <el-button v-if="infoData.isSign=='1'" type="info" size="medium" disabled class="btn-theme disabled">已报名
            </el-button>
        </div>
        <el-dialog title="报名信息" :visible.sync="signInfoShow" width="1200px" center>


            <div class="inviteInfo dashed">
                <h5>招标信息</h5>
                <el-row>
                    <el-col :span="3">投标保证金说明：</el-col>
                    <el-col :span="21">
                        <div v-for="item in cashDepositDesArr">{{ item }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">特别提示：</el-col>
                    <el-col :span="21">
                        <div v-for="item in hotTipArr">{{ item }}</div>
                    </el-col>
                </el-row>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="signInfoShow = false">取 消</el-button>
                <el-button type="primary" @click="signDialog" v-loading="">同意报名</el-button>
            </span>

        </el-dialog>

        <el-dialog title="报 名" :visible.sync="signDialogShow" width="900px" @close="resetForm" center>

            <div class="invite-dialog-form">

                <p v-if="!isStrategy">报名标段</p>
                <div v-if="!isStrategy" v-for="seg,index in signDialogData.entryList" :key="seg.id">

                    <div v-if="seg.hasSign">
                        <el-checkbox disabled>
                            {{ seg.fcurprojectname +'-'+ seg.fbidnum }}
                            <el-tag type="warning" size="small">已报名</el-tag>
                        </el-checkbox>
                    </div>
                    <div v-else>
                        <el-checkbox v-model="signForm.segment" :label="index +','+ seg.fid"
                                     v-bind:disabled="signDialogData.entryList.length == 1 ? true : false "
                                     @change="entryChange">
                            {{ seg.fcurprojectname +'-'+ seg.fbidnum }}
                        </el-checkbox>
                    </div>


                    <div v-if="signDialogData.segmentManage==true && !seg.hasSign" class="invite-dialog-inner">
                        <span>选择项目经理</span> <el-button icon="el-icon-plus" size="mini"  @click="addManager" class=""></el-button>
                        <div v-if="signDialogData.managerList.length==0" class="no-data-tip nomgr"></div>
                        <div v-else>
                            <el-checkbox v-for="o in signDialogData.managerList" :key="o.fid" v-model="signForm.manager"
                                         :label="index +','+ o.id +','+ o.name">{{ o.name }}：{{ o.mobile }}
                            </el-checkbox>
                        </div>
                    </div>
                </div>

                <p v-if="signDialogData.segmentManage==false  || isStrategy">选择项目经理</p>
                <div
                    v-if="signDialogData.segmentManage==false && signDialogData.managerList && signDialogData.managerList.length!=0 || isStrategy">
                    <el-checkbox v-for="o in signDialogData.managerList" :key="o.fid" v-model="signForm.manager"
                                 :label="o.id +','+ o.name">{{ o.name }}：{{ o.mobile }}
                    </el-checkbox>
                </div>

                <p>银行信息</p>
                <div>
                     <el-table :data="bankInfo" border strip >
                        <el-table-column width="55">
                            <template scope="scope">
                                <el-radio :label="scope.row.id" v-model="choosedBankId" @change.native="changeChoosedBank(scope.$index, scope.row)">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center"
                            prop="address"
                            label="银行所在市">
                        </el-table-column>
                        <el-table-column header-align="center" align="center"
                            prop="accountName"
                            label="银行开户行名">
                        </el-table-column>
                        <el-table-column header-align="center" align="center"
                            prop="relationNo"
                            label="银行关联行号">
                        </el-table-column>
                        <el-table-column header-align="center" align="center"
                            prop="name"
                            label="开户行全称">
                        </el-table-column>
                        <el-table-column header-align="center" align="center"
                            prop="bankNo"
                            label="银行账号">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" label="认证状态">
                            <template slot-scope="scope">
                                {{ scope.row.status == '2' ? '已认证' : '未认证' }}
                            </template>
                        </el-table-column>       
                    </el-table>
                </div>


                <p>联系人</p>
                <div v-if="signDialogData.linkpersonList && signDialogData.linkpersonList.length!=0">{{
                    signDialogData.linkpersonList[0].fpersonname || '#姓名缺省#' }}：{{
                    signDialogData.linkpersonList[0].fphone || '#手机号码缺省#' }}
                </div>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="signDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="signUp" :disabled="signUpDisabled">提 交</el-button>
            </span>

        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="新增项目经理" :visible.sync="managerFormVisible" width="640px">
            <el-form :model="manager" label-width="120px" :rules="rules" ref="managerForm" class="supplier-form">
                <el-form-item label="姓名：" prop="name"><el-input type="text" v-model="manager.name" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="身份证：" prop="idCard"><el-input type="text" v-model="manager.idCard" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="手机：" prop="mobile"><el-input type="text" v-model="manager.mobile" auto-complete="off" :maxlength="11"></el-input></el-form-item>
                <el-form-item label="办公电话：" prop="officeTel"><el-input type="text" v-model="manager.officeTel" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="邮箱：" prop="email"><el-input type="text" v-model="manager.email" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="专业：" prop="major"><el-input type="text" v-model="manager.major" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="建造师级别：" prop="grade"><el-input type="text" v-model="manager.grade" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="证书编号：" prop="certificateNo"><el-input type="text" v-model="manager.certificateNo" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="业绩：" prop="achievement"><el-input type="text" v-model="manager.achievement" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="社保证明：" prop="baseFileList">
                    <el-upload
                        :action="uploadApi"
                        :on-success="setPhotoList"
                        :limit="1"
                        :on-exceed="handleExceed"
                        accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                        :file-list="manager.baseFileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>(需提供6个月社保缴纳记录证明)
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="managerFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitManager">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="项目经理" :visible.sync="managersDialogShow" width="1200px" center>

            <el-tabs v-model="managersActive" type="border-card" @tab-click="" class="tabs-margin">

                <div v-if="managersSegList.length==0 && !isStrategy" class="no-data-tip"></div>
                <el-tab-pane v-else v-for="(tab,index) in managersSegList" :name="'tab'+ index" :key="index">
                    <span slot="label">{{ tab.fcurprojectname + (tab.fbidnum?'-':'') + tab.fbidnum }} </span>
                    <el-table :data="managersSegList[index].managers" border stripe size="mini">
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column prop="idCard" label="身份证"></el-table-column>
                        <el-table-column prop="mobile" label="手机"></el-table-column>
                        <el-table-column prop="officeTel" label="办公电话"></el-table-column>
                        <el-table-column prop="email" label="邮箱"></el-table-column>
                        <el-table-column prop="major" label="专业"></el-table-column>
                        <el-table-column prop="grade" label="建造师级别"></el-table-column>
                        <el-table-column prop="certificateNo" label="证书编号"></el-table-column>
                        <el-table-column prop="achievement" label="业绩"></el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == '0' || scope.row.status == null">未认证</span>
                                <span v-if="scope.row.status == '1'">已认证</span>
                                <span v-if="scope.row.status == '2'">已离职</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>

        </el-dialog>


    </div>


</template>

<script type="text/babel">
    import util from '@/util'
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import banner from '@/assets/imgs/banner_invite.png'
    import filter from '@/filter'
    import { managerRules } from '@/util/rules'

    export default {
        name: "invite-info",
        filters: filter,
        data() {
            return {
                downApi: `${util.baseUrl}rest/file/down`,
                uploadApi: `${util.baseUrl}rest/file/upload`,
                // 参数信息
                fid: decodeURIComponent(this.$route.params.fid),
                supplierId: this.$root.stockId,
                // segmentId: '',
                isStrategy: false,
                isSignEnd: false,

                // 基本信息
                infoData: {
                    finvitemethod: '',
                    segmentList: [{managers: []}]
                },
                //报名信息
                finvitecontentArr: '',
                fqulificademandArr: '',
                signNoticeArr: '',
                cashDepositDesArr: '',
                hotTipArr: '',
                signInfoShow: false,
                // 报名相关
                signDialogShow: false,
                signDialogData: {
                    linkpersonList: [{
                        fpersonname: ''
                    }]
                },
                signForm: {
                    segment: [],
                    manager: [],
                    bankIds: ''
                },

                // 项目经理信息
                managersDialogShow: false,
                managersSegList: [],
                managersActive: 'tab0',
                signUpDisabled: false,
                bankInfo: [],
                choosedBankId: '',
                managerFormVisible:false,
                rules: managerRules,
                manager:{
                    name:'',
                    idCard: '',
                    mobile:'',
                    officeTel:'',
                    email:'',
                    major:'',
                    grade:'',
                    certificateNo:'',
                    achievement:'',
                    baseFileList: []
                }

            }
        },
        methods: {
            ...mapActions(['getProvinces','getCities','getProductTypes','getCompanyTypes','checkSUserStock']),

            resetForm: function () {
                this.signForm.manager = []
            },
            // 弹出报名窗口
            signDialog: function () {
                let that = this;
                this.signInfoShow = false;
                // 登录验证
                if (!this.$root.stockId) {
                    this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
                    return false;
                }

                // 报名 canSign 控制
                if (this.infoData.canSign != '1') {
                    if (this.infoData.canSign == '2') {
                        this.$message.error('供应商审核未通过，您暂时无法报名。');
                    }
                    if (this.infoData.canSign == '4') {
                        this.$message.error('供应商产品和服务类型不匹配或未认证。');
                    }
                    return false;
                }

                // 判断供应商是否可以报名（银行卡，投标承诺函）
                this.$http.post('rest/api/invite/project/checkSign', {
                    supplierId: this.$root.stockId
                }).then((res) => {
                    if (!res.data.result) {
                        let tempUrl = ''
                        if (res.data.message.indexOf('承诺函') >= 0) {
                            tempUrl = '/supplier/gysfj'
                        } else if (res.data.message.indexOf('注册资金') >= 0) {
                            tempUrl = '/supplier/other'
                        } else if (res.data.message.indexOf('统一信用社会代码') >= 0) {
                            tempUrl = '/supplier/'
                        } else {
                            tempUrl = '/supplier/bankinfo'
                        }

                        this.$confirm(res.data.message, '提示', {
                            confirmButtonText: '去添加',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push({path: tempUrl,})
                        })

                    } else {
                       this.getSignInfo();
                    }
                })
            },
            getSignInfo:function(){
                let that = this;
                // 获取报名信息
                this.$http.post('rest/api/invite/project/signInfo', {
                    supplierId: this.$root.stockId,
                    projectId: this.fid,
                    segmentId: ''
                }).then((res) => {
                    if (res.data.result) {
                        this.signDialogData = res.data.value;
                        // 如果只有一个默认选中
                        var list = this.signDialogData.entryList;
                        list.forEach(item => {
                            if (item.choosedBankId) {
                                this.choosedBankId = item.choosedBankId
                            }
                        })

                        if (list.length == 1) {
                            this.signForm.segment[0] = '0,' + list[0].fid;
                        }
                        setTimeout(v => {
                            that.signDialogShow = true
                        }, 300)

                    } else {
                        this.$message.error(res.data.message + ' 状态码: ' + res.data.status);
                        this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
                    }
                })

            },

            // 提交报名数据
            signUp: function () {
                this.signUpDisabled = true
                if (this.signForm.segment.length == 0 && !this.isStrategy) {
                    this.$message.error('请至少选择一个标段');
                    this.signUpDisabled = false
                    return false;
                }
                if (!this.choosedBankId) {
                    this.$message.error('请选择银行信息');
                    this.signUpDisabled = false
                    return false;
                }
                var _JSON = {
                    supplierId: this.supplierId,
                    supplierName: this.supplierId,
                    projectId: this.fid,
                    linkPersonId: this.signDialogData.linkpersonList[0].id,
                    linkPersonName: this.signDialogData.linkpersonList[0].fpersonname,
                    bankId: this.choosedBankId
                };

                var URL = 'withSegment';

                // 区分标段报名
                if (this.signDialogData.segmentManage || this.isStrategy) {

                    var arr = [],
                        seg = this.signForm.segment,
                        mgr = this.signForm.manager;

                    // 战略投标
                    if (this.isStrategy) {

                        arr[0] = {
                            managerRequestList: []
                        }

                        for (var i = 0; i < mgr.length; i++) {
                            var pa = mgr[i].split(',');
                            arr[0].managerRequestList.push({
                                id: pa[0],
                                name: pa[1]
                            });
                        }

                        // if (arr[0].managerRequestList.length == 0) {
                        //     this.$message.error('至少选择一个项目经理');
                        //     this.signUpDisabled = false
                        //     return false;
                        // }

                        Object.assign(
                            _JSON, {segmentWithManagersRequestList: arr}
                        )


                    } else {  // 采购

                        for (var i = 0; i < seg.length; i++) {
                            var pa = seg[i].split(',');
                            arr[pa[0]] = {
                                segmentId: pa[1],
                                managerRequestList: []
                            };
                        }

                        for (var i = 0; i < mgr.length; i++) {
                            var pa = mgr[i].split(',');
                            arr[pa[0]].managerRequestList.push({
                                id: pa[1],
                                name: pa[2]
                            });
                        }

                        // 去掉空数据
                        for (var i = 0; i < arr.length; i++) {
                            if (!arr[i]) {
                                arr.splice(i, 1);
                            }
                        }

                        // var choose = true;
                        // for (var i = 0; i < arr.length; i++) {
                        //     if (arr[i].managerRequestList.length == 0) {
                        //         choose = false;
                        //     }
                        // }
                        // if (!choose) {
                        //     this.$message.error('每个标段至少选择一个项目经理');
                        //     this.signUpDisabled = false
                        //     return false;
                        // }

                        Object.assign(
                            _JSON, {segmentWithManagersRequestList: arr}
                        )

                    }

                    // 不区分标段报名
                } else {
                    URL = 'withNoSegment';

                    var arr1 = [],
                        arr2 = [],
                        seg = this.signForm.segment,
                        mgr = this.signForm.manager;

                    for (var i = 0; i < seg.length; i++) {
                        arr1.push(seg[i].split(',')[1]);
                    }

                    if (mgr.length == 0) {
                        this.$message.error('请至少选择一个项目经理');
                        this.signUpDisabled = false
                        return false;
                    }

                    for (var i = 0; i < mgr.length; i++) {
                        var pa = mgr[i].split(',');
                        arr2.push({
                            id: pa[0],
                            name: pa[1]
                        })
                    }

                    Object.assign(
                        _JSON,
                        {
                            entryIdList: arr1,
                            managerList: arr2
                        }
                    )
                }


                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});

                this.$http.post('rest/api/invite/project/sign/' + URL, _JSON).then((res) => {

                    this.signDialogShow = false;
                    loading.close();

                    if (res.data.result) {
                        this.$message({message: '报名成功', type: 'success'})
                        //报名成功才刷新页面
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    } else {
                        this.signUpDisabled = false
                        if (!!res.data.value) {
                            this.$confirm(`${res.data.message}`, '', {
                                confirmButtonText: `${res.data.value}`,
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$router.push({
                                    path: '/supplier/other',
                                })
                            }).catch(() => {

                            })
                        } else {
                            this.$message({message: res.data.message, type: 'error'})
                        }

                        console.log('[报名出错结果]');
                        console.log(res);
                    }

                })
            },
            // 多选框修改变化
            entryChange (value) {
                let chooseArrays = []
                if (value) { // 选中
                    // 只有当不是完全选择的时候才需要计算是否都需要勾选
                    if (this.signForm.segment.length != this.signDialogData.entryList.length) {
                        let chooseIds = []
                        let chooseTogeIds = []
                        this.signForm.segment.forEach((item, i) => {
                            let splitTemp = item.split(',')
                            // 遍历选中项，获取选中
                            chooseIds.push(splitTemp[1])
                            chooseTogeIds.push(this.signDialogData.entryList[splitTemp[0]].togetherIds)
                        })

                        // 遍历标段列表，添加所有需要的参数
                        this.signDialogData.entryList.forEach((item, i) => {
                            if (chooseIds.indexOf(item.fid) >= 0) {
                                // 如果已经被选中
                                chooseArrays.push(i + ',' + item.fid)
                            } else {
                                // 如果不是被选中的
                                if (chooseTogeIds.indexOf(item.togetherIds) >= 0) {
                                    chooseArrays.push(i + ',' + item.fid)
                                }
                            }
                        })

                        this.signForm.segment = chooseArrays
                    }
                } else { // 取消选中
                    let chooseIndexs = []
                    let choosedIds = []
                    // 遍历，取得选中的
                    this.signForm.segment.forEach((item, i) => {
                        let splitTemp = item.split(',')
                        choosedIds.push(splitTemp[1])
                        chooseIndexs.push(splitTemp[0])
                    })
                    // 遍历选中的index
                    chooseIndexs.forEach((item, i) => {
                        let tempObj = this.signDialogData.entryList[item]

                        if (tempObj.togetherIds) {
                            // 如果是合并招标的
                            let allFlag = true;
                            let idsArray = tempObj.togetherIds.split(';');
                            
                            idsArray.forEach(item => {
                                if (choosedIds.indexOf(item) == -1) {
                                    // 只要有一个不在选中里，就取消
                                    allFlag = false
                                }
                            })
                            if (allFlag) {
                                chooseArrays.push(item + ',' + tempObj.fid)
                            }
                        } else {
                            chooseArrays.push(item + ',' + tempObj.fid)
                        }
                    })

                    this.signForm.segment = chooseArrays
                }
            },
            submitManager: function(){
                this.$refs.managerForm.validate(function(valid) {
                    if (valid) {
                        let data = this.manager;
                        const nowLoading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                        this.$http.post('rest/api/invite/project/saveManager', data).then((res)=> {
                            if (res.data.result) {
                                this.$alert(res.data.message)
                                this.managerFormVisible = false;
                                this.getSignInfo()

                            } else {
                                this.$alert(res.data.message)
                            }
                            nowLoading.close();
                        })
                    } else {
                        console.log('error submit!!')
                    }
                }.bind(this))
            },
            changeChoosedBank(index, val) {
                this.choosedBankId = val.id
            },
            getBankInfoList () {
                this.$http.post('rest/api/completeFourInfo/getBankInfo', {
                    stockId: this.supplierId
                }).then((res) => {
                    if (res.data.result) {
                        this.bankInfo = res.data.value
                        
                        // 如果第一个是已认证的直接选择
                        if (this.bankInfo.length > 0 && this.bankInfo[0].status == '2') {
                            this.choosedBankId = this.bankInfo[0].id
                        }
                    }
                })
            },
            addManager(){
                this.manager = {
                    fparentid:this.$root.stockId,
                    name:'',
                    idCard: '',
                    mobile:'',
                    officeTel:'',
                    email:'',
                    major:'',
                    grade:'',
                    certificateNo:'',
                    achievement:'',
                    baseFileList: []
                }
                this.managerFormVisible = true
                this.$nextTick(function(){
                    this.$refs.managerForm.resetFields()
                })
            },
            setPhotoList : function(response, file, fileList) {
                this.manager.baseFileList = []
                this.manager.baseFileList = this.setFileLists(file, fileList)
            },
            handleExceed(files, fileList) {
                this.$message.warning('当前限制选择 1 个文件');
            },
            setFileLists (file, fileList) {
                let fs = [];
                fileList.forEach(function (item) {
                    if (item.response) {
                        let f = item.response.basefiles[0];
                        item.bizTableName = f.biztablename;
                        item.bizTablePkName = f.biztablepkname;
                        item.bizTablePkValue = f.biztablepkvalue;
                        item.fid = f.fid;
                        item.fileCatagoryId = f.filecatagoryid;
                        item.fileDesc = f.filedesc;
                        item.fileOldName = f.fileoldname;
                        item.name = f.fileoldname;
                        item.fileName = f.filename;
                        item.filePath = f.filepath;
                        item.fileSize = f.filesize;
                        item.fileType = f.filetype;
                        item.sort = f.sort;
                    }
                    fs.push(item);
                });
                return fs
            }
        },
        mounted: function () {

            // dev test
            window.ji = this;

            // 获取项目数据
            this.$http.post('rest/api/invite/project/info', {
                projectId: this.fid,
                supplierId: this.supplierId
            }).then((res) => {
                if (res.data.result) {
                    this.infoData = res.data.value;
                    let date1 = new Date(this.infoData.createDate);
                    let date2 = new Date("2022-03-31");
                    if(this.infoData.finvitemethod=='3STRATEGYINVITED' && date1.getTime()<date2.getTime()){
                        this.infoData.fphone = '*';
                    }
                    this.finvitecontentArr = !!this.infoData.finvitecontent ? this.infoData.finvitecontent.split("\n") : [];
                    this.fqulificademandArr = !!this.infoData.fqulificademand ? this.infoData.fqulificademand.split("\n") : [];
                    this.signNoticeArr = !!this.infoData.signNotice ? this.infoData.signNotice.split("\n") : [];
                    this.cashDepositDesArr = !!this.infoData.cashDepositDes ? this.infoData.cashDepositDes.split("\n") : [];
                    this.hotTipArr = !!this.infoData.hotTip ? this.infoData.hotTip.split("\n") : [];
                    this.isStrategy = (this.infoData.finvitemethod.charAt(0) == '3')
                    this.$root.navs.push({name: this.infoData.fname, path: ''})

                    // 验证截止日期
                    if (!this.infoData.finvregisteddeadline) {
                        this.$message.error('报名截止时间缺省');
                    } else {
                        if (new Date().getTime() >= new Date(this.infoData.finvregisteddeadline.replace(/\-/g, '/')).getTime()) {
                            this.isSignEnd = true
                        }
                    }

                }

                if (this.infoData.isSign == '1') {

                    // 有标段 项目经理信息
                    var arr = [];
                    this.infoData.segmentList.forEach(data => {
                        if (data.hasSign) {
                            arr.push(data);
                        }
                    })

                    this.managersSegList = arr;

                    // 战略招标没有标段，将项目模拟成标段
                    if (this.isStrategy) {
                        this.managersSegList = [{fid: '', fcurprojectname: this.infoData.fname, fbidnum: ''}]
                    }

                    this.managersSegList.forEach(data => {
                        this.$http.post('rest/api/invite/project/managers', {
                            supplierId: this.supplierId,
                            projectId: this.fid,
                            segmentId: data.fid
                        }).then((res) => {
                            if (res.data.result) {
                                data.managers = res.data.value;
                            }
                        })
                    })

                }

            })

            this.getBankInfoList()
        },
        created() {
            this.$root.navs = [{name: '招标公告', path: '/inviteList'}];
            this.$root.activeIndex = 'invite'
            this.$root.headImage.src = banner;
            if (window.localStorage.getItem('isInMng')) {
                this.$root.isPublic = false
            }
        }
    }


</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    .winner {
        font-weight: bold;
        font-size: 16px;
        color: var(--cMain);
    }

    .inviteInfo {
        font-size: 14px;
    }

    .inviteInfo.solid {
        height: 100px;
        border-bottom: 1px solid #E6E7E6;
        padding-top: 50px;
    }

    .inviteInfo.solid > p {
        margin: 0 0 24px 0;
        color: #000;
        font-size: 14px;
        text-align: center;
    }

    .inviteInfo.solid > p.title {
        font-size: 18px;
        font-weight: bold;
    }

    .inviteInfo.solid > p.title.strategy::after {
        content: '战略';
        display: inline-block;
        width: 40px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-size: 12px;
        font-weight: normal;
        color: #fff;
        background: var(--cMint);
        border-radius: 2px;
        vertical-align: bottom;
        margin-left: 10px;
    }

    .inviteInfo.dashed {
        padding-bottom: 10px;
        border-bottom: 1px dashed #E6E7E6;
    }

    .inviteInfo.dashed.segment {
        margin-bottom: 20px;
    }

    .inviteInfo h5 {
        color: #252525;
        font-size: 15px;
        margin: 16px 0;
    }

    .inviteInfo h5::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: var(--cMain);
        vertical-align: middle;
        margin: 0 10px;
    }

    .inviteInfo .el-row {
        margin-bottom: 12px;
    }

    .inviteInfo .el-col-3,
    .inviteInfo .el-col-6 {
        color: #5f5f5f;
        text-align: right;
    }

    /* 弹出窗 */
    .invite-dialog-form {
    }

    .invite-dialog-form p {
        color: var(--cTxt2);
        border-left: 4px solid var(--cMain);
        padding-left: 10px;
        line-height: 18px;
        margin: 10px 0;
    }

    .invite-dialog-form > div {
        padding: 4px 48px;
    }

    .invite-dialog-form .invite-dialog-inner {
        padding-left: 60px;
    }

    .invite-dialog-form .invite-dialog-inner p {
        border-left: none;
        padding-left: 0;
        margin: 4px 0;
    }

    .invite-dialog-form label {
        width: 100%;
        margin-left: 0;
        margin-bottom: 4px;
    }

    /* 多标段 */
    .invite-unit {
        display: inline-block;
        width: 49%;
        margin-top: 16px;
    }

    .btn-theme {
        width: 120px;
        margin: 50px 0;
    }

    .btn-managers {
        position: absolute;
        margin-left: 1104px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteInfo.vue